module.exports = __webpack_public_path__ + "img/test-tube.288d282a.svg";